/**
 * External dependencies
 */

import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Box } from '@towersystems/towersystems-design-system';

import './styles.scss';

const Main = ({ className, children, ...rest }) => {

    useEffect(() => {
        // ensure that scroll is always at the top of the page
        // without this; when switching page, it will remain at the current scroll
        // of the previous page
        // 
        // note: this is a hack to quickly solve this for every page ( as all pages currently use main )
        window.scrollTo(0, 0);
    }, []);

	const classes = classNames(className, 'main', {});
	return (
		<Box component='main' className={classes} role='main' {...rest}>
			{children}
        </Box>
	);
};

export default Main;
